import { AuthenticationService } from '../../authentication.service';
import { ErrorService } from '../error.service';
import { SettingsService } from '../../settings.service';
var ErrorPageComponent = /** @class */ (function () {
    function ErrorPageComponent(authenticationService, errorService, settingsService) {
        this.authenticationService = authenticationService;
        this.errorService = errorService;
        this.settingsService = settingsService;
    }
    /**
     * Perform log out from authentication service
     */
    ErrorPageComponent.prototype.doLogout = function () {
        this.authenticationService.logOut();
    };
    /**
    * Clear errors and try again
    */
    ErrorPageComponent.prototype.clearErrors = function () {
        this.errorService.clearErrors();
    };
    return ErrorPageComponent;
}());
export { ErrorPageComponent };
